export default "__VITE_ASSET__Bd$JgxKd__"